import { localStorage } from 'lusha-widgets';

import {
  ON_DEMAND_EMAIL_SUBSCRIPTION_DISMISS_DATE,
  ON_DEMAND_EMAIL_SUBSCRIPTION_KEY,
  ON_DEMAND_INDICATOR_LAST_DISMISS_DATE,
  PLUGIN_ON_DEMAND_SHOW_RESULT_METRIC_KEY,
} from '../models/onDemand/constants';

import { diffBetweenDates } from './date';

export const isLastDismissDateMoreThanAWeek = lastDismissDate => {
  if (!lastDismissDate) {
    return true;
  }

  return diffBetweenDates(new Date(), lastDismissDate)?.days >= 7;
};

export const setEmailSubscriptionBannerDismiss = (userId, numOfDismisses = 1) => {
  localStorage.set(`${ON_DEMAND_EMAIL_SUBSCRIPTION_KEY}${userId}`, numOfDismisses);
};

export const setEmailSubscriptionBannerDismissDate = userId => {
  localStorage.set(`${ON_DEMAND_EMAIL_SUBSCRIPTION_DISMISS_DATE}${userId}`, new Date());
};

export const shouldDisplayOnDemandRedDotIndication = (hasNewContacts, userId) => {
  if (!hasNewContacts) {
    return false;
  }

  const lastIndicationDismissDate = localStorage.get(`${ON_DEMAND_INDICATOR_LAST_DISMISS_DATE}${userId}`, null);
  if (!lastIndicationDismissDate) {
    return true;
  }

  return diffBetweenDates(new Date(), lastIndicationDismissDate)?.days > 1;
};

export const setOnDemandIndicatorDismissDate = userId => {
  localStorage.set(`${ON_DEMAND_INDICATOR_LAST_DISMISS_DATE}${userId}`, new Date());
};

export const buildOnDemandBulkShowClientMetricPayload = () => ({
  metricKey: PLUGIN_ON_DEMAND_SHOW_RESULT_METRIC_KEY,
  labels: {
    isBulk: true,
    isOnDemandContactShow: true,
    isOnDemandHistoryTabSearch: false,
  },
});

export const buildOnDemandShowClientMetricPayload = (isBulk, isOnDemandHistoryTabSearch, isOnDemandContactShow) => ({
  metrics: [{
    metricKey: PLUGIN_ON_DEMAND_SHOW_RESULT_METRIC_KEY,
    labels: {
      isBulk,
      isOnDemandHistoryTabSearch,
      isOnDemandContactShow,
    },
  }],
});
